import DatePreview from '@/components/DatePreview';
import defaultsDeep from 'lodash/defaultsDeep';
import trimStart from 'lodash/trimStart';

const defaultFieldConfig = {
  normalize: value => {
    switch (typeof value) {
      case 'string':
        return trimStart(value);
      default:
        return value;
    }
  }
};

const mapFields = (t, fields) => fields.map(
  (field) => {
    const fieldItem = {
      label: field.label && t(field.label),
      placeholder: field.placeholder && t(field.placeholder),
      colSpan: field.colSpan || 2,
    };

    if (field?.type === 'date') {
      fieldItem.viewWidget = DatePreview;
    }

    return defaultsDeep(fieldItem, field, defaultFieldConfig);
  }
);

export default (t, fields) => {
  if (fields)
    return mapFields(t, fields);
  return fields => mapFields(t, fields);
};
